import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, ResponseContentType } from '@angular/http';
import { ServiceLocator } from '../helpers/service-locator';
import { saveFile } from '../helpers/file-download';
import { AppLocalStorage } from '../helpers/app-local-storage';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams} from '@angular/common/http';
import { AppFile } from '@app/core/models';


@Injectable()
export class FileService {  
  constructor(private http: HttpClient) {
  }

  downloadFile(companyId: number, companyFileId: number) {
    const url = `api/tenants/${companyId}/files/${companyFileId}`;
    // Process the file downloaded
    this.http.get(url, { observe:"response", responseType: "blob" }).subscribe(res => {
      const fileName = res.headers.get("x-filename");
      var blob = new Blob([res.body]);
      saveFile(res.body, fileName);
      return blob;
    });
  }

  downloadFileByPath(path: string) {
    this.http.get(path, { observe: "response", responseType: "blob" }).subscribe(res => {
      const fileName = res.headers.get("x-filename");
      var blob = new Blob([res.body]);
      saveFile(res.body, fileName);
      return blob;
    });
  }
  downloadFileTemplateByPath(fileType: string) {
    this.http.get(fileType, { observe: "response", responseType: "blob" }).subscribe(res => {
      const fileName = res.headers.get("x-filename");
      var blob = new Blob([res.body]);
      saveFile(res.body, fileName);
      return blob;
    });
  }
  UploadFile(formData: FormData): Observable<any> {
    return this.http
      .post('api/dashboard/UploadResourceCenterFile', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  GetResourceCenterFiles(): Observable<AppFile[]> {
    return this.http
      .get('api/dashboard/GetResourceCenterFiles')
      .catch(this.handleError);
  }

  DeleteResourceCenterFile(appFileId: number): Observable<any> {
    return this.http
      .delete(`api/dashboard/files/${appFileId}/DeleteResourceCenterFile`)
      .catch(this.handleError)
  }

  protected handleError(error: HttpErrorResponse) {
    let applicationError = error.headers.get('Application-Error');

    // either applicationError in header or model error in body
    if (applicationError) {
      return Observable.throw(applicationError);
    }

    let modelStateErrors: string = '';
    let serverError = error.error;

    if (!serverError.type) {
      for (let key in serverError) {
        if (serverError[key])
          modelStateErrors += serverError[key] + '\n';
      }
    }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
    return Observable.throw(modelStateErrors || 'Server error');
  }

  downloadFileTemplate(fileName: string) {
    let Params = new HttpParams().set('fileName', fileName);
    const url = `api/lookups/DownloadFileTemplate`;
    this.http.get(url, { observe: "response", responseType: "blob", params: Params }).subscribe(res => {
      const fileName = res.headers.get("x-filename");
      var blob = new Blob([res.body]);
      saveFile(res.body, fileName);
      return blob;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/file.service.ts